import { Controller, Menu } from '@tencent/workbench';
import { RemoveGroupFeature } from './remove-group-feature';
import { INSERT_TEXT_MENU_CONFIGS, config } from './config';
import { MenuKey } from '@framework/workbench/schema/menu-schema/common';
import { Form } from '@tencent/wb-ext-form';
import { FORM_CONFIGS_REMOVEGROUP } from '@framework/workbench/drawer/ui/layout/group/config';

@Controller({
    menuItems: INSERT_TEXT_MENU_CONFIGS,
    formItems: FORM_CONFIGS_REMOVEGROUP,
})
export class RemoveGroupController {
    constructor(private readonly feature: RemoveGroupFeature) {
    }

    @Menu(config.id, 'onClick')
    @Menu(MenuKey.REMOVE_GROUP, 'onClick')
    public onClick() {
        this.feature.callback();
    }

    @Form(config.id, 'onClick')
    public onDrawerClick() {
        this.feature.drawerCallback();
    }
}
